const Monaco = {
  flex: 1,
  position: 'relative',
  foldLevel: 2,
  opacity: 1,
  height: '100%',
  width: '100%',
  beautify: true,
  debounceDuration: 350,
  data: {},
  fileTab: {
    code: 'export default {}',
    type: 'javascript',
    filename: 'app.js',
    fileTabKey: 'unique-key'
  },
  onCodeEditCallback: (editor, _2, el) => {
    el.log(editor.getValue())
  },
  onRender: async (el, s) => {
    // No bare await: a rejected monaco chunk / worker load (the async bundle is
    // ~10MB + a 12MB ts.worker) used to die as an unhandled rejection with the
    // editor never created — surfaced as a permanently blank panel.
    try {
      const { StandaloneMonaco } = await import('@symbo-ls/workspace-monaco')
      await StandaloneMonaco.onRender(el, s)
    } catch (err) {
      console.warn('[monaco] editor mount failed (self-heals on next update):', err)
    }
  },
  onBeforeUpdate: async (_, el, s, ctx, opts) => {
    try {
      const { StandaloneMonaco } = await import('@symbo-ls/workspace-monaco')
      // Self-heal: if the mount-time create failed (rejected monaco chunk,
      // worker error, or a throw while the panel was still display:none at
      // page load), `data.monacoInstance` never exists and StandaloneMonaco's
      // onBeforeUpdate silently DROPS every update (its `!data.monacoInstance`
      // early-return) — the CanvasV2CodeEditor "Edit in Code" panel then opens
      // permanently blank ("opening code editor stucks", 2026-07-06 per Nika).
      // Re-run the create path now: by update time the panel is visible and
      // sized, and el.fileTab already carries the pushed code.
      if (!el.data?.monacoInstance && !el.__monacoRetrying) {
        el.__monacoRetrying = true
        try {
          await StandaloneMonaco.onRender(el, s)
        } finally {
          el.__monacoRetrying = false
        }
      }
      return StandaloneMonaco.onBeforeUpdate(_, el, s, ctx, opts)
    } catch (err) {
      console.warn('[monaco] editor update failed:', err)
      return false
    }
  }
}

export const CodePreviewWidget = {
  display: 'flex',

  flow: 'column',
  position: 'sticky',
  top: '0',
  order: 0,
  widthRange: 'H1',

  Flex_tabs: {},

  Monaco
}
